"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitorInfoService = void 0;
class VisitorInfoService {
    constructor() {
        this.cachedVisitorInfo = undefined;
        this.fetchPromise = null;
    }
    static getInstance() {
        if (!VisitorInfoService.instance) {
            VisitorInfoService.instance = new VisitorInfoService();
        }
        return VisitorInfoService.instance;
    }
    async get() {
        if (this.cachedVisitorInfo) {
            return this.cachedVisitorInfo;
        }
        return this.fetch();
    }
    async fetch() {
        if (this.fetchPromise) {
            return this.fetchPromise;
        }
        this.fetchPromise = (async () => {
            try {
                const response = await fetch(`/relevanceapi/visitorinfo`, {
                    credentials: 'include'
                });
                const data = await response.json();
                this.cachedVisitorInfo = data;
                this.fetchPromise = null;
                return data;
            }
            catch {
                console.error('failed to fetch visitor info data');
                this.fetchPromise = null;
                return undefined;
            }
        })();
        return this.fetchPromise;
    }
    clearCache() {
        this.cachedVisitorInfo = undefined;
        this.fetchPromise = null;
    }
}
exports.VisitorInfoService = VisitorInfoService;
